// extracted by mini-css-extract-plugin
module.exports = {"container":"DataList_container__3JWnN","row":"DataList_row__2rOOe","cell":"DataList_cell__2rDDA","rowLabel":"DataList_rowLabel__ZGOr3","rowContent":"DataList_rowContent__3ZnEb"};